import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core'

@Component({
    selector: 'app-pay-in-process-popup',
    templateUrl: './pay-in-process.component.html',
    styleUrls: ['./pay-in-process.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PayInProcessPopupComponent implements OnInit {
  constructor() {}

  @Input() additionalClasses = ''
  @Input() isMobile = false
  @Input() amount = 0
  @Output() closed: EventEmitter<unknown> = new EventEmitter()

  close() {
    this.closed.emit(true)
  }

  ngOnInit(): void {
  }

}
